import React from 'react'
import PropTypes from 'prop-types'
import flow from 'lodash/flow'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import cx from 'classnames'
import { login } from '../../state/user'
import { auth } from '../../lib'
import { Form, FormGroup, FormControl, InputGroup, Modal, Button } from 'react-bootstrap'

import { UserCheck } from 'styled-icons/fa-solid/UserCheck'
import { Key } from 'styled-icons/fa-solid/Key'

const actionsToProps = dispatch => ({
  login: user => dispatch(login(user))
})

class SignIn extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      user: '',
      userAlert:'',
      passAlert:'',
      alert: ''
    }
  }

  componentDidMount() {
    this.userInput.focus()
  }

  clearAlert = () => this.setState({ alert: '',  userAlert: '', passAlert: ''})
  alert = m => {
    this.setState({ alert: m })
    setTimeout(this.clearAlert, 3000)
  }

  setValue = e => this.setState({ [e.target.id]: e.target.value })
  onEnter = e => {
    if (e.charCode === 13) this.submit(e)
  }

  submit = e => {
    e.preventDefault()

    const { user } = this.state
    if (!user) {
      this.userInput.focus()
      return this.setState({ userAlert: 'user id required', passAlert: '' })
    }
    const pass = this.passInput.value
    if (!pass) {
      this.passInput.focus()
      return this.setState({ userAlert: '', passAlert: 'password required' })
    }

    auth.login(user, pass).then(res => {
      if (res.error) {
        this.alert(res.error)
      } else {
        this.authenticated(res.user)
      }
    })
  }

  authenticated = (user) => {
    auth.setUser(user)
    if (auth.getUser()) {
      this.props.login(user)
      this.changeLocation()
    }
  }

  changeLocation = () => {
    const { location, history } = this.props
    if (location.state && location.state.nextPathname) {
      history.replace(location.state.nextPathname)
    } else {
      history.replace('/')
    }
  }

  changePassword = () => this.props.onModeChange('password')
  signUp = () => this.props.onModeChange('signup')

  render() {
    const { user, userAlert, passAlert, alert } = this.state

    return (
      <Modal.Dialog dialogClassName='modal-login'>
        <div className='text-xs-center bg-primary p-y-4'>
          <span className='font-size-18 line-height-1'>Sign in</span>
        </div>
        { !!alert ? <div className='alert alert-danger'>{alert}</div> : null }

        <Form className='p-a-4'>
          <FormGroup controlId='user' className={ cx({ 'has-warning': !!userAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><UserCheck size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.userInput = r} autoComplete='off' type='text' value={user}
                placeholder='user id' onChange={this.setValue} onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{userAlert}</small>
          </FormGroup>

          <FormGroup className={ cx({ 'has-warning': !!passAlert }) }>
            <InputGroup>
              <InputGroup.Addon className='text-muted'><Key size={14}/></InputGroup.Addon>
              <FormControl inputRef={r => this.passInput = r} type='password' placeholder='password' onKeyPress={this.onEnter}/>
            </InputGroup>
            <small className='form-message dark'>{passAlert}</small>
          </FormGroup>

          <div className='clearfix'>
            <Button className='btn-link font-size-12 pull-xs-left' onClick={this.changePassword}>Change <strong>password</strong> ?</Button>
            <Button className='btn-link font-size-12 text-primary pull-xs-right' onClick={this.signUp}>Have no <strong>account</strong> ?</Button>
          </div>

          <Button type='button' className='btn btn-block btn-lg btn-primary m-t-3' onClick={this.submit}>Sign In</Button>
        </Form>

      </Modal.Dialog>
    )
  }
}

SignIn.propTypes = {
    strings: PropTypes.object
}

const decorators = flow([
  connect(null, actionsToProps),
  withRouter
])

export default decorators(SignIn)



// WEBPACK FOOTER //
// ./src/components/auth/SignIn.js